import Layout from "@components/Layout";
import PostGroupCategory from "@components/PostGroupCategory/index.js";
import SEO from "@components/seo";
import Topic from "@components/Topic/index.js";
import { Col,Row } from "antd";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { DOMAIN } from "src/constants";

import containerStyles from "../../../pages/HomePageStyle.module.scss";
import BigPicture from "./BigPicture/big-picture.js";
import Headline from "./Market/market.js";
import ProductOverview from "./ProductOverview/product-overview";
import styles from "./stylesProduct.module.scss";
import UpcomingEvent from "./UpcomingEvent/upcoming-event";

const ProductPage = ({
  data,
  pageContext,
  posts,
  newTopics,
  newSlickBrokers,
  users,
  slugProductCatogry,
  featurePostGroups
}) => {
  const productAnalysis = data.allWordpressWpProductAnalysis.nodes.find(
    (item) => item.wordpress_id === pageContext.id
  );

  const allWordpressWpProductBigPicture =
    data.allWordpressWpProductBigPicture.nodes;
    
  //TOTO after merge UI broker page
  const breadcrumb = [
    {
      name: "Forex",
      url: "/forex",
    },
    {
      name: productAnalysis.title,
      url: `/forex/${slugProductCatogry}`,
    },
  ];
  const currentDate = dayjs().date();
  const currentMonth = dayjs().month() + 1;

  const productAnalysisPageMetaTitle = `Biểu đồ ${productAnalysis.title}  - Tỉ giá ${productAnalysis.title} hôm nay ${currentDate}/${currentMonth} - VnRebates`;
  const productAnalysisPageMetaDescription = `Truy cập trang VnRebates để xem biểu đồ, dữ liệu lịch sử, tin tức và tỷ giá hiện tại của cặp tiền ${productAnalysis.title} để đầu tư Forex (ngoại hối) hiệu quả nhất.`
  
  const removeFakeLcp = () => {
    const element = document.getElementById("websiteName");
  
    if (!element) return;
    element.remove();
  };

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    };

    setTimeout(() => {
      removeFakeLcp();
    }, 1000);    
  }, [productAnalysis]);

  return (
    <Layout 
      haveAds 
      brokers={newSlickBrokers}
      breadcrumbPageTopic={breadcrumb}
      featurePostGroups={featurePostGroups}
    >
      <div
        className={`${styles["vnr-page-Product"]} ${containerStyles.insideContent}`}
      >
        <SEO 
          title={productAnalysisPageMetaTitle} 
          canonical={`${DOMAIN}${breadcrumb[1].url}`} 
          description={productAnalysisPageMetaDescription}
        />
        <h1
          className={styles["product-title"]}
          dangerouslySetInnerHTML={{
            __html: productAnalysis.title,
          }}
        ></h1>
        <div id="websiteName" className={styles.websiteName}>VNREBATES</div>
        <Row 
          gutter={[
            { xs: 0, sm: 0, md: 24, lg: 40 },
            { xs: 12, sm: 12, md: 24, lg: 40 },
          ]}
          className={styles.pageProductLayout}
        >
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            className={styles.postGroupCol}
          >
            <LazyLoad>
              <PostGroupCategory
                title="Tin tức"
                posts={posts.postsCateTintuc}
                linkLoadMore="/forex/tin-tuc"
                isShowExcerptFirstPost={false}
              />
            </LazyLoad>
          </Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            className={styles.postGroupCol}
          >
            <LazyLoad>
              <PostGroupCategory
                title="Phân tích nhận định"
                posts={posts.postsCatePhantich}
                linkLoadMore="/forex/phan-tich-nhan-dinh"
                isShowExcerptFirstPost={false}
              />
            </LazyLoad>
          </Col>
          
          <Col span={24} className={styles.headlineCol}>
            <Headline product={productAnalysis} />
          </Col>

          <Col span={24} className={styles.bigPictureCol}>
            <LazyLoad>
              <BigPicture
                product={productAnalysis}
                allWordpressWpProductBigPicture={allWordpressWpProductBigPicture}
                text="Bức tranh tổng quan"
                users={users}
              />
            </LazyLoad>
          </Col>
          
          <UpcomingEvent product={productAnalysis} />

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
          >
            <LazyLoad>
              <PostGroupCategory
                title="Kiến thức chung Forex"
                posts={posts.postsCateKienthucForex}
                linkLoadMore="/forex/kien-thuc"
              />
            </LazyLoad>
          </Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
          >
            <LazyLoad>
              <Topic topics={newTopics} />
            </LazyLoad>
          </Col>

        </Row>
        <LazyLoad>
          <ProductOverview product={productAnalysis} />
        </LazyLoad>
      </div>
    </Layout>
  );
};

export default ProductPage;
